import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, makeObservable, observable } from 'mobx'
import JobCreationDialogViewModel from '../../creation/views/JobCreationDialog/JobCreationDialogViewModel'

export default class BulkCopyJobsSuccessViewModel extends ModalViewModel {
  @observable
  private clonedJobIds: string[] = []

  constructor(private jobCreationDialogViewModel: JobCreationDialogViewModel) {
    super()
    makeObservable(this)
  }

  @computed
  get jobCount() {
    return this.clonedJobIds.length
  }

  @action
  open(jobIds: string[]) {
    this.clonedJobIds = jobIds

    super.show()
  }

  @action.bound
  start() {
    this.close()
    this.jobCreationDialogViewModel.open(this.clonedJobIds)
  }
}
